// share article

const sharePostBtn = () => {

  const shareButton = document.querySelector('.interaction__share');
  if (shareButton) {
    shareButton.addEventListener('click', () => {

      const title = document.querySelector('.post-header .entry-title').innerText;
      const url = window.location.href;
      let intro;
      if (document.querySelector('.lead')) {
        intro = document.querySelector('.lead').innerText;
      } else {
        intro = '';
      }


      if (navigator.share) {
        navigator.share({
          title: title,
          url: url,
          text: intro,
        }).then(() => {
          // console.log('Thanks for sharing!');
        })
          .catch(console.error);
      }

    })
  }
};

export default sharePostBtn;
